import { Formik } from "formik";
import { FC, createContext } from "react";
import TableMakeAnAppointment from "./components/TableMakeAnAppointment";

export interface MakeAnAppointmentPageContextProps {}

interface IProps {}

const initialContext = {};

export const MakeAnAppointmentContext =
  createContext<MakeAnAppointmentPageContextProps>(initialContext);

export const MakeAnAppointmentPage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <MakeAnAppointmentContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <TableMakeAnAppointment />
            </div>
          </div>
        </div>
      </MakeAnAppointmentContext.Provider>
    </Formik>
  );
};

export default MakeAnAppointmentPage;
